import { BaseModel } from "sjs-base-model";
import KaikoParametersModel from "../filterableProducts/kaiko/KaikoParametersModel";

// Returned Api Data sample
// const example = {
//     id: 1,
//     type: "Reference",
//     from: 20210101,
//     to: 20210102,
//     product: "Eurex",
//     price: 60,
//     filterableProductParameters: {
//         exchanges: ["FTX", "BlockFi", "3AC", "Voyager Digital"],
//         baseCurrencies: ["BTC"]
//     }
// };

export default class OrderItemModel extends BaseModel {
    id = 0;
    type = "";
    from = 0;
    to = 0;
    product = "";
    price = 0.0;
    isins = [];
    filterableProductParameters = KaikoParametersModel; // maybe new KaikoParametersModel()- TODO: check
    productRemark = "";

    constructor(data) {
        super();
        this.update(data);
    }
}
